import angular from 'angular'
import { vehicleInvoice, ovatBill, invoice } from 'redevConfig'

const listPage = (vehicleInvoice && vehicleInvoice.list) || ''
const addPage = (vehicleInvoice && vehicleInvoice.add) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''
const relatedBillPage = (invoice && invoice.relatedBill) || ''

const list = listPage ? require(`redevelopment/outputManage/vehicleInvoice/${listPage.templateName}`) : require('./view/list.html')
const listCtrl = listPage ? require(`redevelopment/outputManage/vehicleInvoice/${listPage.controllerName}`) : require('./list')
const add = addPage ? require(`redevelopment/outputManage/vehicleInvoice/${addPage.templateName}`) : require('./view/add.html')
const addCtrl = addPage ? require(`redevelopment/outputManage/vehicleInvoice/${addPage.controllerName}`) : require('./add')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('../ovatBill/view/checkBillDetailCtrl.html')
const relatedBill = relatedBillPage ? require(`redevelopment/outputManage/invoice/${relatedBillPage.templateName}`) : require('../invoice1/view/relatedBill_invoice.html')


function configRouter ($stateProvider) {
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice',
        {
            url: '/vehicleInvoice',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'outputManage.FOManage.vehicleInvoice.list',
            title: '机动车票开具',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.list',
        {
            url: '/list',
            template: list,
            controller: 'vehicleListCtrl',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.detail',
        {
            url: '/detail/:waitId',
            template: add,
            controller: 'vehicleInvoiceAdd',
            title: '机动车票详情',
            params: {
                detailFlag: true,
            },
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.detailRed',
        {
            url: '/detailRed/:waitId',
            template: add,
            controller: 'vehicleInvoiceAdd',
            title: '机动车票红票详情',
            params: {
                detailFlag: true,
            },
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.edit',
        {
            url: '/eidt/:waitId',
            template: add,
            controller: 'vehicleInvoiceAdd',
            title: '编辑机动车票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.add',
        {
            url: '/add/:invType',
            template: add,
            controller: 'vehicleInvoiceAdd',
            title: '新增机动车票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.addred',
        {
            url: '/addred/:invType',
            template: add,
            controller: 'vehicleInvoiceAdd',
            title: '新增红字机动车票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.editRed',
        {
            url: '/editRed/:waitId',
            template: add,
            controller: 'vehicleInvoiceAdd',
            title: '编辑红字机动车票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.relatedBill',
        {
            url: '/relatedBill/:waitId',
            template: relatedBill,
            controller: 'invRelatedBillCtrl',
            title: '机动车销售单',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.vehicleInvoice.checkBillDetail',
        {
            url: '/checkBillDetail/:billId',
            template: checkBillDetailCtrl,
            controller: 'checkBillDetailCtrl',
            title: '销售单明细',
        },
    )
}

export default angular
    .module('outputManage.FOManage.vehicleInvoice', [])
    .config(['$stateProvider', configRouter])
    .controller('vehicleListCtrl', listCtrl.default)
    .controller('vehicleInvoiceAdd', addCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/vehicleInvoice/index.js